<template>
	<div>
		<div class="row pl-3 pr-3">
			<div class="col-md-4 col-12 mt-2">
				<h3>CRM</h3>
				<h6>Choose 1 Dealer To Use This Feature</h6>
			</div>
			<div class="col-md-2 col-6 mt-2 flexify">
				<label class="h5">Data By :</label>
				<toggle-button 
					v-model="selected.by"
					:width="100"
					:height="25"
					color="#7dCE94"
					class="ml-2" 
					:sync="true" 
					:labels="{checked: 'SCAN', unchecked: 'DOCUMENT'}"
				/>
				<!-- {{parentFilter.by}} -->
			</div>
			<div class="col-md-2 col-6 mt-2 wrapHighlight">
				<Multiselect
					:options="filterData.dealer.map((x) => x.code)"
					:custom-label="
						(opt) =>
							filterData.dealer.find((x) => x.code == opt).name
					"
					placeholder="Select 1 Dealer"
					:allow-empty="false"
					v-model="parentFilter.dealer"
				/>
			</div>
			<div class="col-md-2 col-6 mt-2 wrapHighlight">
				<flat-pickr
					v-model="selected.date"
					:config="rangeConfig"
					placeholder="Select To Date"
				/>
			</div>

			<div class="col-md-2 col-6 mt-2 wrapHighlight">
				<button class="btn btn-warning w-100" style="height:43px" @click="downloadExcel"><i class="fa fa-download"></i> Download CSV</button>
			</div>
		</div>


		<div class="row pl-3 pr-3">
			<!-- {{data}} -->
			<div class="col-md-6 col-12 mt-3 pr-3">
				<div class="shadow rounded p-15">
					<div class="row" style="height:100px">
						<div class="col-md-5 col-12 mt-3">
							<h3>Sales By Dealer Ring</h3>
						</div>
					</div>

					<div class="mt-3">
						<SalesByDealerRing 
							:data="data.dealerRing"
						/>
						<!-- {{data}} -->
					</div>
				</div>
			</div>

			<div class="col-md-6 col-12 mt-3 pl-3 ">
				<div class="shadow rounded p-15">
					<div class="row" style="height:100px">
						<div class="col-md-6 col-12 mt-auto mb-auto">
							<h3>Sales By Ring Status</h3>
						</div>
						<div class="col-md-3 col-12 wrapHighlight">
							<label>Service Date</label>
							<flat-pickr
								v-model="selected.date_service"
								:config="rangeConfig"
								placeholder="Select To Date"
							/>
						</div>
						<div class="col-md-3 col-12 wrapHighlight">
							<label>Ring</label>
							<Multiselect
								:options="filterData.ring"
								:allow-empty="false"
								v-model="ringFilter.ring"
							/>
						</div>
					</div>

					<div class="mt-3">
						<SalesByRingStatus 
							:data="data.ringStatus"
						/>
						<!-- {{data.ringStatus}} -->
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
const XLSX = require('xlsx')

import { ToggleButton } from 'vue-js-toggle-button'

import SalesByDealerRing from './children/salesByDealerRing.vue'
import SalesByRingStatus from './children/salesByRingStatus.vue'


export default {
	components : {
		Multiselect,
		flatPickr,
		SalesByDealerRing,
		SalesByRingStatus,
		ToggleButton
	},
	data () {
		let start = new moment().startOf('month').format('Y-MM-DD')
		let end = new moment().endOf('month').format('Y-MM-DD')

		let date = `${new moment().startOf('month').format('Y-MM-DD')} to ${new moment().endOf('month').format('Y-MM-DD')}`
		return {
			filterData : {
				dealer: this.$store.getters.getDealer(null, null),
				ring : ['LOKASI' , 'RING 1' , 'RING 2' , 'RING 3' , 'OTHER' , 'PELANGGARAN WILAYAH'],
			},
			parentFilter : {
				start : start,
				end : end,
				dealer : null,
				by : 'SCAN'
			},
			ringFilter : {
				start_service : start , 
				end_service : end,
				ring : 'LOKASI'
			},
			selected : {
				date : date,
				date_service : date,
				by : true
			},
			rangeConfig: {
				mode: 'range',
				altInput: true,
				altInputClass: 'form-control input flatpickr-input',
				animate: !this.isRTL()
			},
			urlTarget : {
				dealerRing : {
					url : '/api/reports/crm/sales-by-dealer-ring?',
					filterVar : null,
					requiredFilter : 'dealer'
				},
				ringStatus : {
					url : '/api/reports/crm/sales-by-ring-status?',
					filterVar : 'ringFilter',
					requiredFilter : 'dealer'
				}
			},
			data : {
				dealerRing : null,
				ringStatus : null
			}
		}
	},
	mounted () {

	},
	watch : {
		parentFilter : {
			deep : true,
			handler () {
				this.loadData(null)
			}
		},
		ringFilter : {
			deep : true,
			handler () {
				this.loadData(['ringStatus'])
			}
		},
		'selected.date' : function () {
			this.parentFilter.start = moment(this.selected.date.split(' to ')[0]).format('Y-MM-DD')
			this.parentFilter.end = moment(this.selected.date.split(' to ')[1] ? this.selected.date.split(' to ')[1] : this.selected.date.split(' to ')[0]).format('Y-MM-DD')
		},
		'selected.date_service' : function () {
			this.ringFilter.start_service = moment(this.selected.date_service.split(' to ')[0]).format('Y-MM-DD')
			this.ringFilter.end_service = moment(this.selected.date_service.split(' to ')[1] ? this.selected.date_service.split(' to ')[1] : this.selected.date_service.split(' to ')[0]).format('Y-MM-DD')
		},
		'selected.by' : function () {
			this.parentFilter.by = this.selected.by ? 'SCAN' : 'DOCUMENT'
		}
	},
	methods : {
		async downloadExcel () {
			try {
				let url = '/api/reports/crm/download?'
				url = this.initialiseFilter(url , this.parentFilter)

				let response = await this.$http.get(url)
				console.log(response.data.data)

				let data = response.data.data

				let firstTab = data.map((x) => {
					return {
						'No Engine' : x.engine_no,
						'Sales Date' : new moment(x.sales_date).format('MMM DD, Y HH:mm:ss'),
						'Lokasi' : x.ring
					}
				})

				let secondTab = data.map((x) => {
					return {
						'No Engine' : x.engine_no,
						'Sales Date' : new moment(x.sales_date).format('MMM DD, Y HH:mm:ss'),
						'Lokasi' : x.ring,
						'Status' : x.status
					}
				})


				let wb = XLSX.utils.book_new()

				let ws1 = XLSX.utils.json_to_sheet(firstTab, {raw:true});
				XLSX.utils.book_append_sheet(wb, ws1, "Sales By Dealer Ring")

				let ws2 = XLSX.utils.json_to_sheet(secondTab, {raw:true});
				XLSX.utils.book_append_sheet(wb, ws2, "Sales By Dealer Ring Status")

				XLSX.writeFile(wb, 'Report CRM.xlsx')
			}
			catch(err) {
				console.log(err)
			}
		},
		loadData (apiLoader = null) {
			if(!apiLoader) {
				apiLoader = ['dealerRing' , 'ringStatus']
			}
			
			for (var i = 0 ; i < apiLoader.length ; i++) {
				let curApi = this.urlTarget[apiLoader[i]]

				let varTarget = apiLoader[i]
				let url = curApi.url

				if(curApi.requiredFilter && !this.parentFilter[curApi.requiredFilter])
					return

				// console.log(curApi.filterVar)
				url = this.initialiseFilter(url , this.parentFilter)

				if(curApi.filterVar)
					url = this.initialiseFilter(url , this[curApi.filterVar])

				this.$http.get(url)
				.then((resp) => {
					this.data[varTarget] = resp.data.data
				})
				.catch((err) => {
					console.log(err);
				})
			}
		}
	}
}
</script>

<style scoped>
	.flexify {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
</style>